import { usePlausibleContext } from '@/shared/PlausibleAnalytics/PlausibleAnalytics';
import {
  subscriptionTypes,
  defaultFreeTrialSubscriptionTypeId,
} from '@rockalingua/shared/subscriptions/constants';

export default function useTrackBuyRelatedEvent() {
  const plausibleContext = usePlausibleContext();

  const trackBuyRelatedEvent = ({
    eventName,
    subscriptionTypeId = defaultFreeTrialSubscriptionTypeId,
    ...props
  }) => {
    const subscriptionType = Object.values(subscriptionTypes).find(
      (subscriptionType) => subscriptionType.id == subscriptionTypeId
    );

    plausibleContext.actions.sendPlausibleEvent(eventName, {
      targetSubscriptionType: subscriptionType.code,
      ...props,
    });
  };

  return trackBuyRelatedEvent;
}
